/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LanguageResource } from './LanguageResource';
import {
    LanguageResourceFromJSON,
    LanguageResourceFromJSONTyped,
    LanguageResourceToJSON,
} from './LanguageResource';
import type { UserIdDto } from './UserIdDto';
import {
    UserIdDtoFromJSON,
    UserIdDtoFromJSONTyped,
    UserIdDtoToJSON,
} from './UserIdDto';

/**
 * 
 * @export
 * @interface SetUserLanguageDto
 */
export interface SetUserLanguageDto {
    /**
     * 
     * @type {LanguageResource}
     * @memberof SetUserLanguageDto
     */
    languageResource: LanguageResource;
    /**
     * 
     * @type {UserIdDto}
     * @memberof SetUserLanguageDto
     */
    userId: UserIdDto;
}

/**
 * Check if a given object implements the SetUserLanguageDto interface.
 */
export function instanceOfSetUserLanguageDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "languageResource" in value;
    isInstance = isInstance && "userId" in value;

    return isInstance;
}

export function SetUserLanguageDtoFromJSON(json: any): SetUserLanguageDto {
    return SetUserLanguageDtoFromJSONTyped(json, false);
}

export function SetUserLanguageDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetUserLanguageDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'languageResource': LanguageResourceFromJSON(json['languageResource']),
        'userId': UserIdDtoFromJSON(json['userId']),
    };
}

export function SetUserLanguageDtoToJSON(value?: SetUserLanguageDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'languageResource': LanguageResourceToJSON(value.languageResource),
        'userId': UserIdDtoToJSON(value.userId),
    };
}

